import store from '@/state/store'
import {
  COMPANY_CREATE,
  COMPANY_READ,
  COMPANY_ACTIVATE,
  COMMODULE_READ,
  DEVICE_PROFILES_READ,
  ORDER_READ,
  TRANSFER_READ,
  MEASURINGPOINT_READ,
  USER_READ,
  USER_CREATE,
  USER_UPDATE,
  CRM_IMPORT,
  TOUR_MANAGEMENT,
  TABLETS_MANAGE,
  SONICO_PROFILE_CREATE,
} from '@/state/helpers/permissions.js'

export const guestRoutes = [
  {
    path: '/login',
    name: 'Login',
    meta: {guest: true},
    component: () => import(/* webpackChunkName: "login" */ '@/components/pages/login/Login.vue'),
  },
  {
    path: '/request-password-reset',
    name: 'RequestPasswordReset',
    meta: {guest: true},
    component: () =>
      import(
        /* webpackChunkName: "requestPasswordReset" */ '@/components/pages/reset-password/RequestPasswordReset.vue'
      ),
  },
  {
    path: '/users/:id/activate/:token',
    name: 'UserActivate',
    meta: {guest: true, external: true},
    component: () =>
      import(
        /* webpackChunkName: "userActivate" */ '@/components/pages/user-activate/UserActivate.vue'
      ),
  },
  {
    path: '/users/:id/reset/:token',
    name: 'UserResetPassword',
    meta: {guest: true, external: true},
    component: () =>
      import(
        /* webpackChunkName: "userResetPassword" */ '@/components/pages/reset-password/UserResetPassword.vue'
      ),
  },
]

export const userRoutes = [
  {
    path: '/dashboard',
    name: 'Dashboard',
    meta: {
      nav: {icon: 'dashboard', group: 1},
    },
    component: () =>
      import(/* webpackChunkName: "dashboard" */ '@/components/pages/dashboard/Dashboard.vue'),
  },
  {
    path: '/reports',
    name: 'Reports',
    meta: {
      nav: {icon: 'report', group: 1},
    },
    component: () =>
      import(/* webpackChunkName: "reports" */ '@/components/pages/reports/Reports.vue'),
  },
  {
    path: '/orders',
    name: 'Orders',
    meta: {
      rule: ORDER_READ,
      nav: {icon: 'orders', group: 2},
    },
    component: () =>
      import(/* webpackChunkName: "orders" */ '@/components/pages/orders/Orders.vue'),
  },
  {
    path: '/devices',
    name: 'Devices',
    props: true,
    meta: {
      nav: {icon: 'meter-icon', group: 2},
    },
    component: () =>
      import(/* webpackChunkName: "devices" */ '@/components/pages/devices/Devices.vue'),
  },
  {
    path: '/device-groups',
    name: 'DeviceGroups',
    meta: {
      nav: {icon: 'group', group: 2},
    },
    component: () =>
      import(/* webpackChunkName: "devices" */ '@/components/pages/device-groups/DeviceGroups.vue'),
    children: [
      {
        path: ':uuid',
        name: 'DeviceGroupCrud',
        component: () =>
          import(
            /* webpackChunkName: "devices" */ '@/components/pages/device-groups/DeviceGroups.vue'
          ),
      },
    ],
  },
  {
    path: '/device-profiles',
    name: 'DeviceProfiles',
    props: true,
    meta: {
      rule: DEVICE_PROFILES_READ,
      nav: {icon: 'profile2', group: 2},
    },
    component: () =>
      import(/* webpackChunkName: "devices" */ '@/components/pages/device-profiles/DeviceProfiles.vue'),
  },
  {
    path: '/keys',
    name: 'Keys',
    meta: {
      rule: COMMODULE_READ,
      nav: {icon: 'key', group: 2},
    },
    component: () => import(/* webpackChunkName: "keys" */ '@/components/pages/keys/Keys.vue'),
  },
  {
    path: '/transfers',
    name: 'Transfers',
    meta: {
      rule: TRANSFER_READ,
      nav: {icon: 'transfer', group: 2},
    },
    component: () =>
      import(/* webpackChunkName: "transfers" */ '@/components/pages/transfers/Transfers.vue'),
  },
  {
    path: '/measuring-points',
    name: 'MeasuringPoints',
    meta: {
      rule: MEASURINGPOINT_READ,
      nav: {icon: 'map-pin', group: 2},
    },
    component: () =>
      import(
        /* webpackChunkName: "devices" */ '@/components/pages/measuring-points/MeasuringPoints.vue'
      ),
  },
  {
    path: '/companies',
    name: 'Companies',
    meta: {
      rule: COMPANY_READ,
      nav: {icon: 'company', group: 3},
    },
    component: () =>
      import(/* webpackChunkName: "companies" */ '@/components/pages/companies/Companies.vue'),
  },
  {
    path: '/companies/create',
    name: 'CompanyCreate',
    meta: {
      rule: COMPANY_CREATE,
    },
    component: () =>
      import(
        /* webpackChunkName: "companyCreate" */ '@/components/pages/companies/CompanyCreate.vue'
      ),
  },
  {
    path: '/companies/:id/activate',
    name: 'CompanyActivate',
    meta: {
      rule: COMPANY_ACTIVATE,
    },
    component: () =>
      import(
        /* webpackChunkName: "companyActivate" */ '@/components/pages/companies/CompanyActivate.vue'
      ),
  },
  {
    path: '/tours',
    name: 'Tours',
    meta: {
      rule: TOUR_MANAGEMENT,
      nav: {icon: 'truck', group: 5},
    },
    component: () =>
      import(/* webpackChunkName: "toursList" */ '@/components/pages/tours/ToursList.vue'),
    children: [
      {
        path: ':id/items',
        name: 'TourDetails',
        props: true,
        meta: {
          rule: TOUR_MANAGEMENT,
        },
        component: () =>
          import(/* webpackChunkName: "tours" */ '@/components/pages/tours/TourDetailsDrawer.vue'),
      },
    ],
  },

  {
    path: '/tours/import',
    name: 'ToursImport',
    component: () =>
      import(/* webpackChunkName: "toursImport" */ '@/components/pages/tours/ToursImport.vue'),
  },
  {
    path: '/users',
    name: 'Users',
    meta: {
      rule: USER_READ,
      nav: {icon: 'users', group: 3},
    },
    component: () => import(/* webpackChunkName: "users" */ '@/components/pages/users/Users.vue'),
  },
  {
    path: '/users/create',
    name: 'UserCreate',
    meta: {
      rule: USER_CREATE,
    },
    component: () =>
      import(/* webpackChunkName: "users" */ '@/components/pages/users/UserCreate.vue'),
  },
  {
    path: '/users/:id',
    name: 'UserEdit',
    meta: {
      rule: USER_UPDATE,
    },
    component: () => import(/* webpackChunkName: "user" */ '@/components/pages/users/UserEdit.vue'),
    beforeEnter: (to, from, next) => {
      if (to.params.id === store.getters['auth/currentUserId']) {
        next('/profile')
      }
      next()
    },
  },
  {
    path: '/crm-import',
    name: 'CrmImport',
    meta: {
      rule: CRM_IMPORT,
    },
    component: () =>
      import(/* webpackChunkName: "crmImport" */ '@/components/pages/crm-import/CrmImport.vue'),
  },
  {
    path: '/tablets',
    name: 'Tablets',
    meta: {
      rule: TABLETS_MANAGE,
      nav: {icon: 'tablet', group: 5},
    },
    component: () =>
      import(/* webpackChunkName: "tablets" */ '@/components/pages/tablets/Tablets.vue'),
  },
  {
    path: '/profile',
    name: 'Profile',
    meta: {
      subnav: {icon: 'users'},
    },
    component: () =>
      import(/* webpackChunkName: "profile" */ '@/components/pages/profile/Profile.vue'),
  },
  {
    path: '/settings',
    name: 'Settings',
    meta: {
      subnav: {icon: 'users'},
    },
    component: () =>
      import(/* webpackChunkName: "settings" */ '@/components/pages/settings/Settings.vue'),
  },
  {
    path: '/logout',
    name: 'Logout',
    beforeEnter(to, from, next) {
      store.dispatch('auth/logOut')
      next('/login')
    },
  },
  {
    path: '/404',
    name: '404',
    props: true,
    component: () => import(/* webpackChunkName: "404" */ '@/components/pages/404/404.vue'),
  },
  {
    path: '/',
    redirect: 'dashboard',
  },
  {
    path: '*',
    redirect: '404',
  },
]

export const groups = [
  {id: 1, name: 'overview'},
  {id: 2, name: 'device_management'},
  {id: 3, name: 'user_management'},
  {id: 4, name: 'administration'},
  {id: 5, name: 'tour_management'},
]

export default [...guestRoutes, ...userRoutes]
